module.exports = __webpack_public_path__ + "static/algolia.47c38c10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/logos/algolia.svg
// module id = 866
// module chunks = 213534597649335